var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneSvgform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 5,
    fill: "#FF5E15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6277 37.1211C47.1746 37.3945 47.5848 38.0098 47.5848 38.6934C47.5848 38.7617 47.5848 38.8984 47.5848 39.0352L45.9441 46.1445C45.7391 46.8965 45.1238 47.375 44.3719 47.375C26.8035 47.375 12.6531 33.2246 12.6531 15.6562C12.6531 14.9043 13.1316 14.2891 13.8836 14.084L20.993 12.4434C21.1297 12.4434 21.2664 12.375 21.3348 12.375C22.0184 12.375 22.6336 12.7852 22.907 13.4004L26.1883 21.0566C26.2566 21.2617 26.325 21.4668 26.325 21.6719C26.325 22.2188 26.0516 22.6973 25.7098 22.9707L21.5398 26.3887C24.0691 31.7207 28.3074 35.959 33.6395 38.4883L37.0574 34.3184C37.3309 33.9766 37.8094 33.7031 38.2879 33.7031C38.5613 33.7031 38.7664 33.7715 38.9715 33.8398L46.6277 37.1211Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSvgform);
export default __webpack_public_path__ + "static/media/phone_svgform.970a51c0efaeb87e3ba2dd65e7d90184.svg";
export { ForwardRef as ReactComponent };